/** Date Spartacus began recording per-user last seen (UK). */
export const SPARTACUS_TRACKING_START_DATE = '2026-07-01'

export const SPARTACUS_UK_TIMEZONE = 'Europe/London'
export const SPARTACUS_DEFAULT_RANGE_DAYS = 30
export const SPARTACUS_MAX_DATE_RANGE_DAYS = 366

export const SPARTACUS_DEFAULT_PAGE_SIZE = 25
export const SPARTACUS_MAX_PAGE_SIZE = 200
export const SPARTACUS_PAGE_SIZE_OPTIONS = ['25', '50', '100', '200']

export const SPARTACUS_DEFAULT_SORT_BY = 'ordersInPeriod'
export const SPARTACUS_DEFAULT_SORT_DIR = 'desc'
